import { render, staticRenderFns } from "./EditPublicationBasedAd.vue?vue&type=template&id=5113a385&"
import script from "./EditPublicationBasedAd.vue?vue&type=script&lang=js&"
export * from "./EditPublicationBasedAd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports